import { render, staticRenderFns } from "./legalCheck.vue?vue&type=template&id=aec5d720"
import script from "./legalCheck.vue?vue&type=script&lang=ts"
export * from "./legalCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports